import {Order} from '../../types';
import {deliveryDateTypes} from '../../static_data/deliveryDateTypes';

export function isAsapDelivery(order: Order): boolean {
    if (order.deliveryDateType === deliveryDateTypes.ASAP.key) {
        return true;
    }
    return false;
}